import { defineComponent as _defineComponent } from 'vue'
import { WarningBarInfo } from '@/services/billing-utils';
import { PropType, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BillingWarningBar',
  props: {
  subWarningBarInfo: { type: Object as PropType<WarningBarInfo|null>, required: false, default: null },
  smsWarningBarInfo: { type: Object as PropType<WarningBarInfo|null>, required: false, default: null },
  paymentWarningBarInfo: { type: Object as PropType<WarningBarInfo|null>, required: false, default: null },
},
  setup(__props) {

const props = __props;



const warningBarInfo = computed(
  () => props.subWarningBarInfo ?? props.paymentWarningBarInfo ?? props.smsWarningBarInfo,
);


return { __sfc: true,props, warningBarInfo }
}

})